module.exports = __webpack_public_path__ + "static/img/top-bg-icon.e1df1d40.png";